import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const LikeChatResult = lazyWithPreload(() => import('./LikeChatResult'))
